import React from 'react';
import { Typography, CardContent, CardMedia, makeStyles, IconButton, Tooltip, Grid } from '@material-ui/core';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import { Delete } from '@material-ui/icons';
import ReactPlayer from 'react-player';
import { connect } from 'react-redux';

const useStyles = makeStyles({
    mediaImage: {
        height: 200
    },
    audioItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    audioIcon: {
        position: 'absolute',
        zIndex: 10,
        fontSize: '4em',
    }
});

function MediaItem(props) {
    const { path, type, id, handleOpen, handleDelete, index, createdAt, translations } = props;
    const classes = useStyles();

    switch (type) {
        case 'signature':
            return (
                <div>
                    <CardMedia
                        onClick={() => { handleOpen(path, type, index, id) }}
                        className={classes.mediaImage}
                        image={path}
                    />
                    <CardContent>
                        <Grid container spacing={0} direction="row" alignItems="center" justify="space-between">
                            <Grid item>
                                <Typography variant="body2" component="p">
                                    {createdAt}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title={translations["delete_media"] || "Delete media"}>
                                    <IconButton id={path} aria-label={translations["delete_media"] || "Delete media"} onClick={() => handleDelete(id, true)}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </CardContent>
                </div>
            );
        case 'image':
            return (
                <div>
                    <CardMedia
                        onClick={() => { handleOpen(path, type, index, id) }}
                        className={classes.mediaImage}
                        image={path}
                    />
                    <CardContent>
                        <Grid container spacing={0} direction="row" alignItems="center" justify="space-between">
                            <Grid item>
                                <Typography variant="body2" component="p">
                                    {createdAt}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title={translations["delete_media"] || "Delete media"}>
                                    <IconButton id={path} aria-label={translations["delete_media"] || "Delete media"} onClick={() => handleDelete(id)}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </CardContent>
                </div>
            );
        case 'audio':
            return ReactPlayer.canPlay(path) ? (
                <div>
                    <div
                        onClick={() => handleOpen(path, type, index, id)}
                        className={classes.audioItem}
                    >
                        <ReactPlayer
                            playing={false}
                            width="100%"
                            height="200px"
                            url={path}
                        />
                        <AudiotrackIcon
                            color='primary'
                            className={classes.audioIcon}
                        />
                    </div>
                    <CardContent>
                        <Grid container spacing={0} direction="row" alignItems="center" justify="space-between">
                            <Grid item>
                                <Typography variant="body2" component="p">
                                    {createdAt}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title={translations["delete_media"] || "Delete media"}>
                                    <IconButton id={path} aria-label={translations["delete_media"] || "Delete media"} onClick={() => handleDelete(id)}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </CardContent>
                </div>) : null;
        case 'video':
            return ReactPlayer.canPlay(path) ? (
                <div>
                    <ReactPlayer
                        onClick={() => { handleOpen(path, type, index, id) }}
                        width="100%"
                        height="200px"
                        playing={false}
                        url={path}
                    />
                    <CardContent>
                        <Grid container spacing={0} direction="row" alignItems="center" justify="space-between">
                            <Grid item>
                                <Typography variant="body2" component="p">
                                    {createdAt}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title={translations["delete_media"] || "Delete media"}>
                                    <IconButton id={path} aria-label={translations["delete_media"] || "Delete media"} onClick={() => handleDelete(id)}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </CardContent>
                </div>
            ) : null;
        default:
            return ReactPlayer.canPlay(path) ? (
                <div>
                    <ReactPlayer
                        onClick={() => { handleOpen(path, type, index, id) }}
                        width="100%"
                        height="200px"
                        playing={false}
                        url={path} />
                    <CardContent>
                        <Grid container spacing={0} direction="row" alignItems="center" justify="space-between">
                            <Grid item>
                                <Typography variant="body2" component="p">
                                    {createdAt}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip title={translations["delete_media"] || "Delete media"}>
                                    <IconButton id={path} aria-label={translations["delete_media"] || "Delete media"} onClick={() => handleDelete(id)}>
                                        <Delete />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </CardContent>
                </div>) : null;
    }
}

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

export default connect(mapStateToProps, null)(MediaItem);